import { render, staticRenderFns } from "./all-media-block.vue?vue&type=template&id=f28c4e36"
import script from "./all-media-block.vue?vue&type=script&lang=js"
export * from "./all-media-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports